import type { FaireProductEntity } from "../../entity_types/product";

export const p_ztaxcybkrg: FaireProductEntity = {
  token: "p_ztaxcybkrg",
  type: "product",
  name: "Late Checkout",
  brandToken: "b_qkjzzyp79p",
  brandName: "Nose Dive",
  imageUrl:
    "https://cdn.faire.com/fastly/62d2fb1147b4ee745fdcda19bb3ee00ef0785bf13e4d99e3375e76a427475c53.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6384d6c68f5de366815e5d012069c02a6ff398aa647b87ef0648cf934c5a1902.jpeg",
    "https://cdn.faire.com/fastly/9bf21c37b4c0fff0c72f8a1f377c4d4301ab8413a977c30a170a455860ba8193.jpeg",
    "https://cdn.faire.com/fastly/5eb75490fef1f20693b9aea13b1bdaea02fd7e77b4f42254d5c81a32bbc68b95.jpeg",
    "https://cdn.faire.com/fastly/feaebef005e7d639cc6426dd8f046034705f9ea5ca95c4d8d6a371458dbc5f43.jpeg",
  ],
  priceDollars: 22,
  description:
    "Slow mornings, undone sheets. A santal-forward blend of creamy wood and subtle spice — warm and lingering, like the quiet luxury of staying a little longer.\n\nTop Notes: sandalwood, eucalyptus, cedarwood, leather\n\nMiddle Notes: lily of the valley, amber mist\n\nBase Notes: musk, oud wood, cardamum, iris, ambrox\n\nFounder's Note: \"If you're a santal fan you will simply fall in love with this candle. It took us several tries to make this candle unique and stand out amongst other santal scents. I would smell like this candle every day if I could. It is so luxurious and makes you want to nose dive into it. \n",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:03.676Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
